const TOKEN_KEY = 'neobreed_token';
const USER_KEY = 'neobreed_user';

export const saveToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const saveUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getUser = () => {
  const userData = localStorage.getItem(USER_KEY);
  if (!userData) return null;
  try {
    return JSON.parse(userData);
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const hasRole = (allowedRoles) => {
  const user = getUser();
  if (!user) return false;
  return allowedRoles.includes(user.role);
};

export const getDashboardPath = (role) => {
  switch (role) {
    case 'super_admin':
      return '/superadmin/dashboard';
    case 'doctor':
      return '/doctor/dashboard';
    case 'clinic_admin':
      return '/clinic/dashboard';
    case 'employee':
      return '/employee/dashboard';
    case 'credit_admin':
      return '/credit-admin/credits';
    case 'mother':
      return '/mom/dashboard';
    default:
      return '/login';
  }
};

export const logout = () => {
  removeToken();
  window.location.href = '/login';
};
